<template>
  <div class="row">
    <template v-if="isCalculatorApplicant">
      <div class="col-12 col-md-12 q-mt-xl-md">
        <div class="q-pa-md border-radius-top q-pt-md-none">
          <CalculatorBusinessDetails
            v-if="enableBusinessDetails"
            :shouldShow="showBusinessDetails"
            @businessDetailsCreated="businessDetailsCreated"
          />
          <CalculatorNominatePrimary
            v-if="!primaryApplicant"
            :shouldShow="showNominatePrimary"
            @primaryApplicantCreated="primaryApplicantCreated"
          />
          <CalculatorConfirmPrimary v-else @primaryApplicantCreated="primaryApplicantCreated" />
          <CalculatorNominateSecondary
            v-if="enableNominateSecondary"
            :shouldShow="showNominateSecondary"
            @secondaryApplicantCreated="secondaryApplicantCreated"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="col-12 col-md-4">
        <ProgressSteps :step="2"></ProgressSteps>
      </div>
      <div class="col-12 col-md-8">
        <div class="q-pa-md border-radius-top q-pt-md-none">
          <NominatePrimary v-if="!primaryApplicant" :shouldShow="showNominatePrimary" @primaryApplicantCreated="primaryApplicantCreated" />
          <ConfirmPrimary v-else @primaryApplicantCreated="primaryApplicantCreated" />
          <NominateSecondary
            v-if="enableNominateSecondary"
            :shouldShow="showNominateSecondary"
            @secondaryApplicantCreated="secondaryApplicantCreated"
          />
          <BusinessDetails
            v-if="enableBusinessDetails"
            :shouldShow="showBusinessDetails"
            @businessDetailsCreated="businessDetailsCreated"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NominatePrimary from './NominatePrimary';
import ConfirmPrimary from './ConfirmPrimary';
import BusinessDetails from './BusinessDetails';
import NominateSecondary from './NominateSecondary';

import CalculatorNominatePrimary from '@/pages/CalculatorAuth/BusinessDetails/NominatePrimary';
import CalculatorConfirmPrimary from '@/pages/CalculatorAuth/BusinessDetails/ConfirmPrimary';
import CalculatorBusinessDetails from '@/pages/CalculatorAuth/BusinessDetails/BusinessDetails';
import CalculatorNominateSecondary from '@/pages/CalculatorAuth/BusinessDetails/NominateSecondary';
import ProgressSteps from '../../components/Molecules/ProgressSteps';
import MyCustomFunctions from '../../mixins/MyCustomFunctions.js';

export default {
  name: 'BusinessDetailsIndex',
  mixins: [MyCustomFunctions],
  data: function () {
    return {
      showNominatePrimary: true,
      showBusinessDetails: false,
      showNominateSecondary: false,
      enableBusinessDetails: false
    };
  },
  components: {
    ProgressSteps,
    NominatePrimary,
    BusinessDetails,
    NominateSecondary,
    ConfirmPrimary,
    CalculatorBusinessDetails,
    CalculatorNominatePrimary,
    CalculatorNominateSecondary,
    CalculatorConfirmPrimary
  },
  computed: {
    ...mapGetters({
      calculatorApplicant: 'vehicleApplication/isCalculatorApplicant'
    }),
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard,
      user: (state) => state.auth.user
    }),
    primaryApplicant() {
      return this.scoreboard?.primaryApplicant ? this.scoreboard?.primaryApplicant : null;
    },
    businessDetails() {
      return this.scoreboard?.businessDetails ? this.scoreboard?.businessDetails : null;
    },
    secondaryApplicant() {
      return this.scoreboard?.secondaryApplicant ? this.scoreboard?.secondaryApplicant : null;
    },
    hasSecondaryApplicant() {
      return this.scoreboard?.entityDetails?.hasSecondaryApplicant ? this.scoreboard?.entityDetails?.hasSecondaryApplicant : null;
    },
    enableNominateSecondary() {
      if (
        this.primaryApplicant &&
        this.primaryApplicant.confirmed &&
        this.primaryApplicant.userId == this.user.id &&
        this.hasSecondaryApplicant &&
        this.hasSecondaryApplicant == 'yes'
      )
        return true;
      else return false;
    },
    isCalculatorApplicant() {
      return this.calculatorApplicant;
    }
  },
  created() {
    if (this.primaryApplicant && this.primaryApplicant.confirmed) {
      this.primaryApplicantCreated();
    } else return;

    if (this.secondaryApplicant) {
      this.secondaryApplicantCreated();
    } else return;

    if (
      this.businessDetails &&
      this.businessDetails.entityDetails &&
      this.businessDetails.annualRevenue &&
      this.businessDetails.financeDetails &&
      this.businessDetails.financeDetails.completed
    ) {
      this.businessDetailsCreated();
    } else return;
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    primaryApplicantCreated: function (primaryApplicantInput = null) {
      if (primaryApplicantInput) {
        this.updateVehicleApplicationState({
          value: primaryApplicantInput,
          propertyFirst: 'primaryApplicant'
        });
      }
      this.showNominatePrimary = false;
      this.showBusinessDetails = true;
      this.showNominateSecondary = true;
      if (this.primaryApplicant && this.primaryApplicant.userId == this.user.id && !this.enableNominateSecondary) {
        this.enableBusinessDetails = true;
      }
    },
    businessDetailsCreated: async function () {
      this.showNominatePrimary = false;
      this.showBusinessDetails = false;
      this.showNominateSecondary = false;
      if (this.scoreboard && this.scoreboard.status != 'approvals') {
        await this.updateVehicleApplication('approvals', 'status');
        this.$router.push({ name: 'approvals' });
      }
    },
    secondaryApplicantCreated: async function (secondaryApplicantInput = null) {
      if (secondaryApplicantInput) {
        this.updateVehicleApplicationState({
          value: secondaryApplicantInput,
          propertyFirst: 'secondaryApplicant'
        });
      }
      this.showNominatePrimary = false;
      this.showBusinessDetails = true;
      this.showNominateSecondary = false;
      if (this.primaryApplicant && this.primaryApplicant.userId == this.user.id) {
        this.enableBusinessDetails = true;
      }
    }
  }
};
</script>
